import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  authUser: null,
  authToken: null,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthUser: (state, action) => {
      state.authUser = action.payload;
    },
    setAuthToken: (state, action) => {
      state.authToken = action.payload;
    },
  },
});

export const { setAuthUser, setAuthToken } = authSlice.actions;
export default authSlice.reducer;
